/* eslint-disable */
import moment from 'moment';
// import React from 'react';
import { Add, Remove } from '@mui/icons-material';
import { ListTable } from '@/Components/ListTable';
import { getHigherUnitName } from '@/Helpers';
import Pagination from 'rsuite/Pagination';
import styles from './ScanWiseTable.module.scss';

const TABLE_COLUMNS = [
	{
		title: 'QRCode',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock In Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},
    {
        title: 'Price Per Unit',
        config: {
            type: 'DATA',
        },
    },
	{
		title: 'Expiry',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	QRCode: 'qrCode',
	'Stock Id': 'stockId',
	'Stock In Date': 'stockedInAt',
	Expiry: 'expiryTime',
	Quantity: 'variantId',
    'Price Per Unit': 'rate',
};

export const QrWiseTable = (props) => {
	const { data, measurement, itemDetails, page, total, pageSize, onPageChange } = props;

	const SPECIAL_ITEMS = {
		QRCode: (qrCodeVal) => {
			return (
				<a
					className='underline text-blue-400'
					href={`/console2/order/tracking?type=qrCode&value=${qrCodeVal}`}
					target='_blank'
					rel='noreferrer'
				>
					{qrCodeVal}
				</a>
			);
		},
		'Stock Id': (stockId) => {
			return (
				<div className='text-left'>
					{stockId}
				</div>
			);
		},
		Unit: () => {
			const unit = itemDetails?.unit ?? 'gram';
			return (
				<div className='text-left'>
					{getHigherUnitName(unit)}
				</div>
			);
		},
		Quantity: (variantId, itemObj) => {
			let icon = <Add className='text-green-900' />;
			if (itemObj?.movementType === 'Stocked Out') {
				icon = <Remove className='text-red-800' />;
			}
			return (
				<div className='flex items-center gap-1 justify-start'>
					{itemObj?.movementType && <div className='animate-pulse'>{icon}</div>}
					<p className=''>
						{itemObj?.qty}
					</p>
				</div>
			);
		},
		'Stock In Date': (stockInDate) => {
			return (
				<div className='text-left'>
					{moment(stockInDate)?.format('YYYY-MM-DD HH:mm A')}
				</div>
			);
		},
		Expiry: (expiryDate) => {
			return (
				<div className='text-left'>
					{moment(expiryDate)?.format('YYYY-MM-DD HH:mm A')}
				</div>
			);
		},
        'Price Per Unit': (rate) => {
            return (
                <div className='text-left'>
                    {rate ? (
                        <>
                            ₹{rate} / {getHigherUnitName(itemDetails?.unit ?? 'gram')}
                        </>
                    ) : '-'}
                </div>
            );
        },
	};

	const getRowStyles = (ele) => {
		if (ele?.movementType === 'Stocked In') {
			return 'bg-[#00ff0d41]';
		}
		if (ele?.movementType === 'Stocked Out') {
			return 'bg-[#ff0c0c41]';
		}
		return '';
	};

	return (
		<div className={`${styles.root} ${styles.small}`}>
			{total > 0 && onPageChange && (
				<div className='flex justify-end px-4 py-2 border-b border-gray-200'>
					<Pagination
						prev
						next
						first
						last
						ellipsis
						boundaryLinks
						maxButtons={7}
						size='sm'
						layout={['total', '-', 'pager']}
						total={total}
						limit={pageSize ?? 20}
						activePage={page ?? 1}
						onChangePage={onPageChange}
					/>
				</div>
			)}
			<ListTable
				// allowExport={false}
				allowCheckList={false}
				// showBtnContainer={false}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={data?.map((ele) => {
					return {
						...ele,
						rowStyles: getRowStyles(ele),
					};
				})}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};
